export default __webpack_public_path__ + "static/media/start_thumb.6fdc09f0.png";